import { Component, Input, OnInit } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { AppLayer } from 'app/services/layer.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-feat-layer-tabs',
  templateUrl: './feat-layer-tabs.component.html',
  styleUrls: ['./feat-layer-tabs.component.css']
})
export class FeatLayerTabsComponent implements OnInit {

	@Input() disabled: boolean;
	@Input() onlyCurrent: boolean;

	selectedLayer: AppLayer;

	displayedListFix: AppLayer[];
	displayedListOther: AppLayer[] = [];
	displayedOther: AppLayer;

	// showDropdown = false;

	private addrLayer: AppLayer;
	private centerlineLayer: AppLayer;
	private provLayer: AppLayer;

	private layerList: AppLayer[];

	// private selectedTabKey: TabKey;

	private isSelectingOther: boolean;

	private displayedLayersSub: Subscription;
	private selectedLayerSub: Subscription;
	private selectedTabSub: Subscription;
	constructor(
		private activityService: ActivityService,
		private attrIndexService: AttrIndexService
	) { }

	onClickTab(layer: AppLayer) {
		if (this.disabled) {
			return;
		}
		// if (this.showDropdown) {
		// 	return;
		// }
		if (this.isSelectingOther) {
			this.isSelectingOther = false;
			return;
		}
		if (layer !== this.selectedLayer) {
			this.selectedLayer = layer;
			this.activityService.selectedLayerBS.next({
				layer: this.selectedLayer
			})
		}
	}
	onClickSelectOther() {
		this.isSelectingOther = true;
	}
	onSelectOther() {
		// this.displayedOther = layer;
		this.onClickTab(this.displayedOther);
	}
	// onToggleOtherDropdown() {
	// 	this.showDropdown = !this.showDropdown;
	// }
	private onLayerListUpdate() {
		this.addrLayer = this.layerList.find(l => l.category.code === this.attrIndexService.cateCodeAddress);
		this.centerlineLayer = this.layerList.find(l => l.category.code === this.attrIndexService.cateCodeCenterline);
		// this.provLayer = this.layerList.find(l => l.category.code === this.attrIndexService.cateCodeProvBdry);
		this.displayedListOther = this.layerList.filter(l => l !== this.addrLayer && l !== this.centerlineLayer && l !== this.provLayer);
		this.displayedListFix = [];
		if (this.addrLayer) {
			this.displayedListFix.push(this.addrLayer);
		}
		if (this.centerlineLayer) {
			this.displayedListFix.push(this.centerlineLayer);
		}
		if (this.provLayer) {
			this.displayedListFix.push(this.provLayer);
		}
		if (this.displayedListOther.length) {
			if (this.displayedOther) {
				this.displayedOther = this.displayedListOther.find(i => i.category.code === this.displayedOther.category.code);
			} else {
				this.displayedOther = this.displayedListOther[0];
			}
		}
	}
	private updateLayerListAsCurrent(layers: AppLayer[]) {
		if (this.selectedLayer) {
			this.layerList = layers.filter(l => l.category.code === this.selectedLayer.category.code);
		}
	}
	ngOnInit() {
		this.displayedLayersSub = this.activityService.displayedLayerListBS.subscribe(data => {
			this.layerList = data.layers;
			this.onLayerListUpdate();

			if (this.onlyCurrent) {
				this.updateLayerListAsCurrent(data.layers);
			}
		});
		this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(data => {
			if (!data.layer) {
				this.selectedLayer = null;
			} else {
				this.selectedLayer = this.layerList.find(l => l.category.code === data.layer.category.code);
				if (this.onlyCurrent) {
					this.updateLayerListAsCurrent(this.activityService.displayedLayerListBS.getValue().layers);
				}
			}
		});
		// this.selectedTabSub = this.activityService.selectedTabBS.subscribe(data => {
		// 	this.selectedTabKey = data.tabKey;
		// });
	}
	ngOnDestroy(): void {
		this.displayedLayersSub.unsubscribe();
		this.selectedLayerSub.unsubscribe();
		// this.selectedTabSub.unsubscribe();
	}

}
